













import { defineComponent, reactive, ref } from '@vue/composition-api';

import {
  createItemGroup,
  updateItemGroup,
} from '@/api/index';

const CommonModalWithMaterialTypeEditor = defineComponent({
  setup(props, { emit }) {
    const modal = ref(null);
    const form = reactive({
      id: -1,
      name: '',
      call: async () => {
        if (form.id === -1) {
          await createItemGroup({
            name: form.name,
          });
        } else {
          await updateItemGroup(form.id, {
            name: form.name,
          });
        }
        emit('done');
      },
    });

    function open(material = { id: -1, name: '' }) {
      form.id = material.id;
      form.name = material.name;
      (modal.value as any).open();
    }
    function close() {
      form.id = -1;
      form.name = '';
      (modal.value as any).close();
    }

    return {
      open,
      close,
      form,
      modal,

    };
  },
});

export default CommonModalWithMaterialTypeEditor;
